import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import Notiflix from "notiflix";

import Review from "../../assets/images/Review.png";

class UploadCsv extends Component {
    constructor(props) {
        super(props);
        this.state = {
            StateData: []
        };
    }

    componentDidMount() {
        Notiflix.Loading.Init({
            svgColor: "#777f80",
        });

        // Notiflix.Loading.Dots("Please wait...");

      
    }
    render() {
        return (
            <React.Fragment>
                <div className="d-flex justify-content-center">
                    <div class="mt-3 price-card py-5 col-10">
                        <div>
                            <h3 className="stepper-heading d-flex justify-content-center align-items-center">Review the uploaded CSV File and Confirm the update of Prices</h3><br />
                        </div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 justify-content-center">
                                    <Card className="d-flex justify-content-center align-items-center download-container">
                                        <a className="download-csv">
                                            <img className="download-image" src={Review} style={{ height: '300px', width: '300px' }}></img>
                                        </a>
                                        <button className="btn align-items-center downloadcsv-button mt-4 mb-4">Review</button>

                                    </Card>
                                    <h4 className="d-flex justify-content-center">Review the uploaded CSV File and Submit the update of Prices</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default UploadCsv